var webCoobyApp = {
	coobyUtils: {
		getParam: function (name) {//获取参数
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			var r = window.location.search.substr(1).match(reg);
			if (r != null)
				return unescape(r[2]);
			return null;
		},
		isWechat: function () {// 判断是否微信浏览器
			var userAgent = navigator.userAgent;
			if (userAgent != undefined && userAgent.indexOf("MicroMessenger") > -1) {
				return true;
			} else {
				return false;
			}
		},
		isEmptyString: function (s) {//是否空字符串
			if (s != undefined && s != null && s.length > 0) {
				return false;
			} else {
				return true;
			}
		},
		isNotEmptyString: function (s) {
			return !this.isEmptyString(s);
		},
		setShareInfo: function (options) {//设置分享信息
			if (webCoobyApp.coobyApp.isApp()) {
				webCoobyApp.coobyApp.setShareInfo(options);
			}
		},
		delURLPar: function (destiny, par)//删除地址栏的参数 
		{
			var pattern = par + '=([^&]*)';
			var replaceText = "";
			if (destiny.match(pattern)) {
				var reg = new RegExp(pattern, "g"); //创建正则RegExp对象   
				tmp = destiny.replace(reg, replaceText);
				return tmp;
			}
			return destiny;
		},
		replaceShareUrl: function (shareUrl) {
			if (shareUrl.indexOf("&code=") > 0 && shareUrl.indexOf("&state=") > 0) {
				shareUrl = this.delURLPar(shareUrl, "&code");
				shareUrl = this.delURLPar(shareUrl, "&state");
			}

			if (shareUrl.indexOf("http://52bji.com") == 0) {
				shareUrl = shareUrl.replace("http://52bji.com", "http://www.52bji.com");
			}
			else if (shareUrl.indexOf("https://52bji.com") == 0) {
				shareUrl = shareUrl.replace("https://52bji.com", "https://www.52bji.com");
			}
			return shareUrl;
		},
		//APP下载按钮
		downApp: function () {
			var appStore = "https://itunes.apple.com/cn/app/ai-bian-ji/id1126688420?mt=8";
			var yinyongbao = "http://a.app.qq.com/o/simple.jsp?pkgname=com.cooby.editor";
			var userAgent = navigator.userAgent;
			if (userAgent.indexOf("iPhone") > 0 || userAgent.indexOf("iPad") > 0) { //苹果
				if (userAgent.indexOf("MicroMessenger") > 0 || userAgent.indexOf("weibo") > 0 || userAgent.indexOf("QQ") > 0) {
					window.location.href = yinyongbao;
				} else {
					window.location.href = appStore;
				}
				return;
			}
			if (userAgent.indexOf("Android") > 0) {//安卓
				window.location.href = yinyongbao;
				return;
			}
			window.location.href = yinyongbao;
		}
	},
	coobyApp: {
		//1.获取sessionCode
		getAPPSessionCode: function () {//测试通过
			var _appSessionCode = "";
			try {
				if ("undefined" != typeof (appSessionCode_Cooby)) {
					_appSessionCode = appSessionCode_Cooby;
				}
				else {
					_appSessionCode = window.JSCoobyNewsWebView.getAPPSessionCode();
				}
			}
			catch (ex) { }

			if (_appSessionCode == undefined || _appSessionCode == "undefined" || _appSessionCode == "") {
				return "";
			}
			return _appSessionCode;
		},
		//2.获取app版本号(安卓对应版本code)
		getAppVersion: function () {//测试通过
			if ("undefined" != typeof (appVersion_Cooby)) {
				return appVersion_Cooby;
			}
			try {
				return window.JSCoobyNewsWebView.getAppVersion();
			} catch (ex) {
				return "";
			}
		},
		//获取设备版本号	
		getAvlVersions: function () {//测试通过
			if ("undefined" != typeof (avlVersions_Cooby)) {
				return avlVersions_Cooby;
			}
			try {
				return window.JSCoobyNewsWebView.getAvlVersions();
			} catch (ex) {
				return "";
			}
		},
		//获取设备系统	返回设备系统（andorid/ios）0:安卓；1:苹果
		getAvlSystemName: function () {//测试通过
			if ("undefined" != typeof (avlSystemName_Cooby)) {
				return avlSystemName_Cooby;
			}
			try {
				return window.JSCoobyNewsWebView.getAvlSystemName();
			} catch (ex) {
				return "";
			}
		},
		//获取设备ID(唯一)	
		getAvlMachineId: function () {//测试通过
			if ("undefined" != typeof (avlMachineId_Cooby)) {
				return avlMachineId_Cooby;
			}
			try {
				var _avlMachineId = window.JSCoobyNewsWebView.getAvlMachineId();
				if (_avlMachineId == undefined || _avlMachineId == "undefined" || _avlMachineId == "") {
					return "";
				}
				return _avlMachineId;
			} catch (ex) {

			}
			return "";
		},
		//获取设备名（不唯一）
		getAvlMachineName: function () {//测试通过
			if ("undefined" != typeof (avlMachineName_Cooby)) {
				return avlMachineName_Cooby;
			}
			try {
				return window.JSCoobyNewsWebView.getAvlMachineName();
			} catch (ex) {
				return "";
			}
		},
		//获取会员ID
		getAPPMemberId: function () {//测试通过
			var _appMemberId = "";
			if ("undefined" != typeof (appMemberId_Cooby)) {
				_appMemberId = appMemberId_Cooby;
			}
			try {
				_appMemberId = window.JSCoobyNewsWebView.getAPPMemberId();
			} catch (ex) {

			}
			if (_appMemberId == undefined || _appMemberId == "undefined" || _appMemberId == "") {
				return "";
			}

			return _appMemberId;
		},
		//图片幻灯片
		doSlideshow: function (jsonObj) {//测试通过
			var json = JSON.stringify(jsonObj);
			try {
				window.webkit.messageHandlers.doSlideshow.postMessage(json);
			} catch (err1) {
				try {
					window.JSCoobyNewsWebView.doSlideshow(json);
				} catch (err2) {
				}
			}
		},
		//登录窗口
		openLogin: function ()//测试通过
		{
			try {
				window.webkit.messageHandlers.openLogin.postMessage("");
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.openLogin();
				}
				catch (ex2) {

				}
			}
		},
		//可分享新窗口
		openSharePage: function (jsonObj) {
			if (jsonObj.navTitle == undefined || jsonObj.navTitle == "undefined") {
				jsonObj.navTitle = "";
			}
			if (!jsonObj.isSetKeyboard) {//键盘是否弹起
				jsonObj.isSetKeyboard = false;
			}
			if (!jsonObj.showTitleBar) {//是否显示导航
				jsonObj.showTitleBar = true;
			}
			if (!jsonObj.isExtBrowsers) {//是否外部浏览器打开
				jsonObj.isExtBrowsers = false;
			}
			var json = JSON.stringify(jsonObj);
			try {
				window.JSCoobyNewsWebView.openSharePage(json);
			}
			catch (ex1) {
				try {
					window.webkit.messageHandlers.openSharePage.postMessage(json);
				}
				catch (ex2) {
					window.open(jsonObj.url);
				}
			}
		},
		//网页设置分享内容
		setShareInfo: function (json) {
			if (json == undefined) {
				return;
			}
			if (json.titleSuffix != undefined) {//分享标题后缀不为空
				json.title = json.title + " " + json.titleSuffix;
			}

			var shareUrl = json.url;
			//替换分享地址
			json.url = webCoobyApp.coobyUtils.replaceShareUrl(shareUrl);

			try {
				window.webkit.messageHandlers.setShareInfo.postMessage(JSON.stringify(json));
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.setShareInfo(JSON.stringify(json));
				}
				catch (ex2) {
				}
			}
		},
		//更多分享
		openMoreShare: function (obj) {
			var json = JSON.stringify(obj);
			try {
				window.webkit.messageHandlers.openMoreShare.postMessage(json);
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.openMoreShare(json);
				}
				catch (ex2) {

				}
			}
		},
		//打开会员个人主页
		openMemberPage: function (memberId) {
			try {
				window.webkit.messageHandlers.openMemberPage.postMessage(memberId);
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.openMemberPage(memberId);
				}
				catch (ex2) {

				}
			}
		},
		contentHidenSucc: function () {//140824新增方法，截图成功后的回调
			try {
				window.webkit.messageHandlers.contentHidenSucc.postMessage("");
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.contentHidenSucc();
				}
				catch (ex2) {

				}
			}
		},
		contentRestoreSucc: function () {//140824新增方法，恢复成功后的回调
			try {
				window.webkit.messageHandlers.contentRestoreSucc.postMessage("");
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.contentRestoreSucc();
				}
				catch (ex2) {

				}
			}
		},
		appInform: function (obj) {//140829新增方法，调用app的举报方法
			var json = JSON.stringify(obj);
			try {
				window.webkit.messageHandlers.AppInform.postMessage(json);
				alert(json);
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.AppInform(json);
				}
				catch (ex2) {

				}
			}
		},
		copyText: function (str) {//170904新增方法，复制成功之后告诉app数据,直接传字符串给app
			try {
				window.webkit.messageHandlers.copyText.postMessage(str);
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.copyText(str);
				}
				catch (ex2) {

				}
			}
		},
		submitToAppLike: function (obj) {//140831新增方法，提交点赞的一些数据给app
			var json = JSON.stringify(obj);
			try {
				window.webkit.messageHandlers.submitToAppLike.postMessage(json);
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.submitToAppLike(json);
				}
				catch (ex2) {

				}
			}
		},
		openComment: function () {//170906新增方法，调用ios的键盘
			alert("打开app键盘");
			try {
				window.webkit.messageHandlers.openComment.postMessage();
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.openComment(json);
				}
				catch (ex2) {

				}
			}
		},
		isExistsMethod: function (methodName) {// 检查是否存在app方法
			try {
				if (methodName == "setData" || methodName == "getData") {
					if (window.JSCoobyNewsWebView && eval("window.JSCoobyNewsWebView." + methodName)) {
						return true;
					}
					else if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
						return true;
					}
				}
				else {
					if ((window.JSCoobyNewsWebView && eval("window.JSCoobyNewsWebView." + methodName))
						|| eval("window.webkit.messageHandlers." + methodName + ".postMessage")) {
						return true;
					}
				}
			}
			catch (ex) { }
			return false;
		},
		//判断是否是APP
		isApp: function () {//测试通过
			try {
				if (window.JSCoobyNewsWebView) {
					return true;
				}

				if (this.getAvlVersions() != "") {//可以获取到版本号
					return true;
				}
			}
			catch (ex) { }
			return false;
		},
		isBefore: function (androidVersions, iosVersions) {
			try {
				// 设备系统0:安卓；1:苹果
				var systemName = webCoobyApp.coobyApp.getAvlSystemName();
				if ("0" == systemName) {
					if (androidVersions == "") return false;
					var versions = webCoobyApp.coobyApp.getAppVersion();
					if (parseInt(versions) >= parseInt(androidVersions)) {//手机版本>=传入的版本号表示新版本
						return false;
					}
				} else if ("1" == systemName) {
					if (iosVersions == "") return false;
					// 版本号
					var versions = webCoobyApp.coobyApp.getAppVersion();
					if (iosVersions == versions) { //相同版本表示新版本
						return false;
					}
					var versionsArr = versions.split(".");//2.1.9
					var iosVersionsArr = iosVersions.split(".");//2.2.0
					for (var i = 0; i < 3; i++) {
						if (parseInt(versionsArr[i]) > parseInt(iosVersionsArr[i])) {//手机版本>传入的版本号表示新版本
							return false;
						}
						else if (parseInt(versionsArr[i]) < parseInt(iosVersionsArr[i])) {//手机版本<传入的版本号表示旧版本
							return true;
						}
					}
				}
			} catch (err) {
			}
			return true;
		},
		//页面后退功能 
		pageBack: function () {//测试通过
			try {
				window.webkit.messageHandlers.pageBack.postMessage("");
			}
			catch (ex1) {
				try {
					window.JSCoobyNewsWebView.pageBack();
				}
				catch (ex2) {

				}
			}
		},
		//关闭APP中的加载中
		dismisshud: function () {
			try {
				window.webkit.messageHandlers.dismisshud.postMessage("");
			}
			catch (err1) {
				try {
					window.JSCoobyNewsWebView.dismisshud();
				} catch (err2) {
				}
			}
		}
	},
	weixinUtil: {
		options: {
			weixinUserAgent: "MicroMessenger",// 微信useragent
			configUrl: "/mw/custominfo_getWeixinShareConfig.do"// 获取配置的url
		},
		/**
		 *  {title:'分享标题', desc:'分享描述', imgUrl:'分享图片'}
		 */
		setShareParam: function (options) {// 设置分享参数
			if (!this.isWeixinBrowser()) {
				return;
			}

			var jsSdkUrl = "http://res.wx.qq.com/open/js/jweixin-1.0.0.js";
			if (window.location.protocol == "https:") {
				jsSdkUrl = "https://res.wx.qq.com/open/js/jweixin-1.0.0.js";
			}

			var _this = this;
			this.loadJs(jsSdkUrl, function () {
				_this.initConfig(options);
			});
		},
		initConfig: function (options) {
			var _this = this;
			_this.getWxconfig().then(function (wxConfig) {
				wx.config(wxConfig);
				wx.ready(function () {
					options.imgUrl = options.imgUrl;
					options.link = _this.emptyTo(options.link,
						window.location.href);
					// 分享到朋友圈
					wx.onMenuShareTimeline(options);
					// 分享给朋友
					wx.onMenuShareAppMessage(options);
					// 分享到QQ
					wx.onMenuShareQQ(options);
					// 分享到微博
					wx.onMenuShareWeibo(options);
					// 分享到QQ空间
					wx.onMenuShareQZone(options);
				});
			});
		},
		isWeixinBrowser: function () {// 判断是否微信浏览器
			return navigator.userAgent.indexOf(this.options.weixinUserAgent) >= 0;
		},
		getWxconfig: function () {// 获取微信配置
			console.log(this.options.configUrl);
			return $.post(this.options.configUrl, {
				thisUrl: window.location.href
			}).then(function (resultStr) {
				console.log(resultStr);
				var result = $.parseJSON(resultStr);
				console.log(result);
				if (result.code == '200') {
					return JSON.parse(result.msg);
				} else {
					throw new Error(result.msg);
				}
			});
		},
		emptyTo: function (target, defaultVal) {
			if (target == undefined || target == '') {
				return defaultVal;
			}
			return target;
		},
		loadJs: function (loadUrl, callMyFun) {//动态加载
			var loadScript = document.createElement('script');
			loadScript.setAttribute("type", "text/javascript");
			loadScript.setAttribute('src', loadUrl);
			console.log(loadUrl)
			document.getElementsByTagName("head")[0].appendChild(loadScript);
			// 判断服务器
			if (navigator.userAgent.indexOf("IE") >= 0) {
				// IE下的事件
				loadScript.onreadystatechange = function () {
					if (loadScript
						&& (loadScript.readyState == "loaded" || loadScript.readyState == "complete")) {
						// 表示加载成功
						loadScript.onreadystatechange = null;
						callMyFun()// 执行回调
					}
				}
			} else {
				loadScript.onload = function () {
					loadScript.onload = null;
					callMyFun();
				}
			}
		}
	},
	weixinUtil: {
		options: {
			weixinUserAgent: "MicroMessenger",// 微信useragent
			configUrl: "/mw/custominfo_getWeixinShareConfig.do"// 获取配置的url
		},
		/**
		 *  {title:'分享标题', desc:'分享描述', imgUrl:'分享图片'}
		 */
		setShareParam: function (options) {// 设置分享参数
			if (!this.isWeixinBrowser()) {
				return;
			}

            alert("设置成功");
			var jsSdkUrl = "http://res.wx.qq.com/open/js/jweixin-1.0.0.js";
			if (window.location.protocol == "https:") {
				jsSdkUrl = "https://res.wx.qq.com/open/js/jweixin-1.0.0.js";
			}

			var _this = this;
			this.loadJs(jsSdkUrl, function () {
				_this.initConfig(options);
            });
		},
		initConfig: function (options) {
			var _this = this;
			_this.getWxconfig().then(function (wxConfig) {
				wx.config(wxConfig);
				wx.ready(function () {
					options.imgUrl = options.imgUrl;
					options.link = _this.emptyTo(options.link,
						window.location.href);
					// 分享到朋友圈
					wx.onMenuShareTimeline(options);
					// 分享给朋友
					wx.onMenuShareAppMessage(options);
					// 分享到QQ
					wx.onMenuShareQQ(options);
					// 分享到微博
					wx.onMenuShareWeibo(options);
					// 分享到QQ空间
					wx.onMenuShareQZone(options);
				});
			});
		},
		isWeixinBrowser: function () {// 判断是否微信浏览器
			return navigator.userAgent.indexOf(this.options.weixinUserAgent) >= 0;
		},
		getWxconfig: function () {// 获取微信配置
			return $.post(this.options.configUrl, {
				thisUrl: window.location.href
			}).then(function (resultStr) {
				var result = $.parseJSON(resultStr);
				console.log(result);
				if (result.code == '200') {
					return JSON.parse(result.msg);
				} else {
					throw new Error(result.msg);
				}
			});
		},
		emptyTo: function (target, defaultVal) {
			if (target == undefined || target == '') {
				return defaultVal;
			}
			return target;
		},
		loadJs: function (loadUrl, callMyFun) {//动态加载
			var loadScript = document.createElement('script');
			loadScript.setAttribute("type", "text/javascript");
			loadScript.setAttribute('src', loadUrl);
			document.getElementsByTagName("head")[0].appendChild(loadScript);
			// 判断服务器
			if (navigator.userAgent.indexOf("IE") >= 0) {
				// IE下的事件
				loadScript.onreadystatechange = function () {
					if (loadScript
						&& (loadScript.readyState == "loaded" || loadScript.readyState == "complete")) {
						// 表示加载成功
						loadScript.onreadystatechange = null;
						callMyFun()// 执行回调
					}
				}
			} else {
				loadScript.onload = function () {
					loadScript.onload = null;
					callMyFun();
				}
			}
		}
	}
};

try {
	module.exports = webCoobyApp;
}
catch (e) { }
// export default webCoobyApp;



// WEBPACK FOOTER //
// ./src/js/coobyApp.js